import React from 'react'
import Bg from '@images/wp/wp-bg.webp'
import abimg1 from '@images/wp/1.webp'
import abimg2 from '@images/wp/2.webp'
import abimg3 from '@images/wp/wp-3.webp'
import { LanguageContext } from '../../index';


const About = (props) => {
    const { language } = React.useContext(LanguageContext);

    const content = {
        experienceYears: language === 'pl' ? 'Lat doświadczenia' : 'Years of Experience',
        title: language === 'pl' ? 'Z pasją tworzymy' : 'We passionately create',
        timeless: language === 'pl' ? 'ponadczasowe' : 'timeless',
        woodenFloors: language === 'pl' ? 'drewniane podłogi' : 'wooden floors',
        welcomeMessage: language === 'pl'
            ? 'WITAMY W ŚWIECIE RZEMIOSŁA I NATURY'
            : 'WELCOME TO THE WORLD OF CRAFTSMANSHIP AND NATURE',
    };

    return (
        <section id="about" className="wp-section pt-150 rmb-100" style={{ backgroundImage: `url(${Bg})` }}>
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-7">
                        <div className="wp-images rmb-150">
                            <div className="experience-year">
                                <span className="number">16</span>
                                <h4>{content.experienceYears}</h4>
                            </div>
                            <img src={abimg1} alt="Wordpress" />
                            <img src={abimg2} alt="Wordpress" />
                        </div>
                    </div>
                    <div className="col-lg-5">
                        <div className="wp-content ml-50 rml-0 rpt-30">
                            <div className="section-title mb-10">
                                <h6>FABRI</h6>
                                <h2>
                                    {content.title} <br />
                                    <span>{content.timeless}</span> <br />
                                    <span className="thin">{content.woodenFloors}</span>
                                </h2>
                                <h4>{content.welcomeMessage}</h4>
                            </div>
                            <img src={abimg3} alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;